import { Link } from "react-router-dom";
import { RENEWAL_PAYMENT_REQUIRED } from "../config";

const C = { ink: "var(--pr-ink)", ink2: "var(--pr-ink2)", green: "var(--pr-green)" };

export const RenewalNudgeCard = ({ renewal, className = "", suffix = "" }) => {
  if (!renewal?.prompt) return null;
  const left = renewal.relays_left ?? 0;
  const done = left <= 0;
  return (
    <div className={`rounded-2xl p-5 lg:p-6 pr-card-tint ${className}`} style={{ background: "var(--pr-tint-green)" }} data-testid={`renewal-nudge-card${suffix}`}>
      <p className="text-sm font-bold mb-1" style={{ color: C.ink }}>
        {done
          ? "🏁 Relay race complete, what a run!"
          : `🏁 Final stretch, ${left} relay${left === 1 ? "" : "s"} left in this race.`}
      </p>
      <p className="text-xs leading-relaxed mb-2" style={{ color: C.ink2 }} data-testid={`renewal-nudge-pricing${suffix}`}>
        Your next 52 never starts (or bills) automatically. You choose when.
      </p>
      {!RENEWAL_PAYMENT_REQUIRED && (
        <p className="text-xs leading-relaxed mb-3 rounded-lg px-2.5 py-1.5" style={{ background: "var(--pr-tint-gold)", color: "var(--pr-accent-gold-text)" }} data-testid={`renewal-nudge-beta-note${suffix}`}>
          🎁 Beta perk: start your next race during the beta and it's on the house.
        </p>
      )}
      <Link
        to="/app/renew"
        className="block w-full py-3 rounded-full font-bold text-xs text-center pr-btn-primary"
        data-testid={`renewal-nudge-cta${suffix}`}
      >
        Set up my next 52 →
      </Link>
    </div>
  );
};
